import React, {useContext} from 'react';
import {Input} from 'reactstrap';
import SocialFilters from './SocialFilters';
import {numberWithCommas} from 'utils/other';
import {EntityContext} from 'contexts/EntityContext';
import Loader from 'components/Loader';

const EntityFilters = (props) => {
    const {entitySocialFilters, activeEntitySort, entitySocialCount} = useContext(EntityContext);

    const {
        totalCount, searchResultsLength, updatingFilters, activeSort, activeEntity,
        toggleSocialFilters, handleEntitySortChange, auth
    } = props;

    return (
        <div className="mt-4 d-flex justify-content-between align-items-center">
            <>
                {/*{activeSort !== 2 ?*/}
                <div className="position-relative" style={{top: '5px'}}>
                    {` ${numberWithCommas(totalCount) === '' ? 'No'
                        : numberWithCommas(totalCount)} results found 
                            ${(
                        (activeSort === 2 &&
                            Object.keys(entitySocialFilters).filter((key) => {
                                return key !== 'google_ozmosys' && entitySocialFilters[key] === true;
                            }).length === 0) ||
                        (activeSort !== 2 && totalCount > 0 && searchResultsLength === 0)) ?
                    '(No results are visible based on your filters)' : ''}`}
                </div>
                {/*:*/}
                {/*<div className="position-relative" style={{top: '5px'}}>*/}
                {/*    {Object.keys(entitySocialFilters).filter((key) => {*/}
                {/*        return key !== 'google_ozmosys' && entitySocialFilters[key] === true;*/}
                {/*    }).length === 0 &&*/}
                {/*    <div>No active sources selected</div>*/}
                {/*    }*/}
                {/*</div>*/}
                {/*}*/}
            </>
            <div className="d-flex align-items-center">
                {activeEntity && Object.keys(entitySocialFilters).filter((key) => entitySocialFilters[key] !== null).length > 0 &&
                <div className="ml-3 d-flex align-items-center">
                    {updatingFilters &&
                    <Loader small/>
                    }
                    <SocialFilters
                        socialFilters={entitySocialFilters}
                        toggleSocialFilters={toggleSocialFilters}
                        activeView="entities"
                        updating={false}
                        socialCount={entitySocialCount}
                        activeEntity={activeEntity}
                        inHeader
                        hideLabel
                        auth={auth}
                    />
                </div>
                }
                <div
                    className="home-page-filters__filter-container d-flex justify-content-between align-items-center ml-5">
                    {/*<div className="" style={{fontWeight: '700', whiteSpace: 'nowrap'}}>Sort by &nbsp;</div>*/}
                    <Input className="home-page-filters__sort-dropdown"
                           onChange={(e) => handleEntitySortChange(e.target.value)}
                           value={activeEntitySort} type="select" name="sorting">
                        <option value={0}>Date (Newest to Oldest)</option>
                        <option value={1}>Date (Oldest to Newest)</option>
                        <option value={2}>Source</option>
                    </Input>
                </div>
            </div>
        </div>
    );
};

export default EntityFilters;
